<div class="w-full h-full pt-5" *ngIf="filterDataLoading">
    <lazy-loader></lazy-loader>
</div>
<div class="w-full h-full">
    <advance-filter [module]="'JOB'" [options]="filterOptionsConfig" [filterOptionalValues]="filterOptionalValues"
        [hideHeaderFooter]="true" [filterFieldOptions]="filterFieldOptions"
        *ngIf="filterFieldOptions.length && !filterDataLoading"
        [additionalFilters]="additionalFilters"
        (applyOrSaveFilter)="onChangeFilters($event)"></advance-filter>
</div>